import React from "react";
import { Helmet } from "react-helmet";
import IconSignForSale from "../../icons/IconSignForSale";
import LiveHeader from "../common/LiveHeader";
import LiveRdcPoweredBy from "./LiveRdcPoweredBy";
import {
  Container,
  Description,
  PoweredByContainer,
  Text,
  Title
} from "./styled/live-rdc";
import {
  Card,
  CardHeader,
  CardIcon,
  Cell,
  Highlight,
  Grid,
  GridContainer
} from "./styled/live-rdc-listing-completeness";
import IconHomeMulti from "../../icons/IconHomeMulti";
import IconBed from "../../icons/IconBed";
import IconBathtub from "../../icons/IconBathtub";
import IconBoxSize from "../../icons/IconBoxSize";
import IconPhotoAlt from "../../icons/IconPhotoAlt";
import IconSchools from "../../icons/IconSchools";
import IconCoin from "../../icons/IconCoin";

const items = [
  {
    icon: <IconSignForSale />,
    label: "List price",
    description:
      "We will align on a listing price for your home based on similar comparables and how much buyer demand we see locally, 50% of potential buyers filter only by price (and nothing else)"
  },
  {
    icon: <IconHomeMulti />,
    label: "Property type",
    description:
      "Property type is a required field on Realtor.com® as over 85% daily home searches are made with this filter"
  },
  {
    icon: <IconBed />,
    label: "Bedrooms count",
    description:
      "Number of bedrooms is a required field on Realtor.com® as buyers value it 280% more than other fields"
  },
  {
    icon: <IconBathtub />,
    label: "Bathrooms count",
    description:
      "Number of bathrooms is required because buyers value it 240% more than other fields"
  },
  {
    icon: <IconBoxSize />,
    label: "Living area (sq ft) size",
    description:
      "Buyers value the living area (sq ft) of a home 152% more than other property features"
  },
  {
    icon: <IconPhotoAlt />,
    label: "More than 11 photos of the home added to listing",
    description:
      "Listings that get more potential buyer interest tend of have at least 11 photos, Realtor.com® recommends 20+ photos to generate more buyer interest"
  },
  {
    icon: <IconSchools />,
    label: "At least 1 school added to listing",
    description:
      "Agents should enter a minimum of one high school district/name to attract more interest from potential buyers"
  },
  {
    icon: <IconCoin />,
    label: "HOA/association fee amount",
    description:
      "HOA fee amount is a required field, even if it is $0. About 16% of buyers place value on knowing the homeowner association (HOA) fee"
  }
];

function LiveRdcListingCompleteness() {
  return (
    <>
      <Helmet>
        <title>Listing Completeness</title>
      </Helmet>
      <LiveHeader>Listing Completeness</LiveHeader>
      <Container>
        <Title>Why is Realtor.com®'s 'Listings That Sell' list valuable?</Title>
        <Description>
          When agents publish your property on the market, Realtor.com®
          recommends using the checklist below to help position your property so
          it matches other listings that are successfully selling over the past
          year.{" "}
          <Highlight>
            The checklist helps position listings to perform better and
            increases attention (views, tours) from potential buyers on
            Realtor.com®.
          </Highlight>
        </Description>
        <GridContainer>
          <Grid>
            {items.map((item) => (
              <Cell key={item.label}>
                <Card>
                  <CardIcon>{item.icon}</CardIcon>
                  <CardHeader>
                    <Text strong>{item.label}</Text>
                  </CardHeader>
                  <Text small>{item.description}</Text>
                </Card>
              </Cell>
            ))}
          </Grid>
        </GridContainer>
        <Text small>
          Listing completeness recommendations are driven by analysis of
          potential buyer interest in features of successful (sold) listings on
          Realtor.com® over the past year. Potential buyer interest and value
          are determined based on the number of views, clicks, shares, repeat
          visits, tour requests, and propensity to make offers or buy properties
          containing particular features as compared to listings without such
          features in addition to the percentage of buyers that are filtering
          particular fields in their search to find these properties.
        </Text>
        <PoweredByContainer>
          <LiveRdcPoweredBy />
        </PoweredByContainer>
      </Container>
    </>
  );
}

export default LiveRdcListingCompleteness;
